import { set_dto_selected_merchant_or_product } from "../../classes/dto-setters/dto-setter";
import { GET_SELECTED_MERCHANT_OR_PRODCUCT } from "../../database/get-stored-data";
import { dto_selected_merchant_or_product } from "../../classes/dto-selected-merchant-or-product";
import { dto_StartupPageLoadInfo } from "../../classes/dto-mobile-settings";
import { dto_MobileAppCategory } from "../../classes/dto-mobile-app-category";
import { PT_PRODUCT_LIST } from "../../routes/stack/paths/pt-home";
import { KEY_GENERATOR } from "../../functions/funtion";
import { dto_Merchant } from "../../classes/dto-merchant";
import { Carousel } from "react-responsive-carousel";
import React from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";

export default class SliderImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      dataBanner: JSON.parse(dto_StartupPageLoadInfo.AdvertisementUrl),
      isSplit: false,
    };
  }

  componentDidMount() {
    let array = JSON.parse(dto_StartupPageLoadInfo.AdvertisementUrl);
    let structuredArray = [];
    let isSplit = false;

    for (let i = 0; i < array.length; i++) {
      let parts = array[i].split("λ");
      for (let j = 0; j < parts.length; j++) {
        let itemParts = parts[j].split("|");
        if (itemParts.length === 4) {
          structuredArray.push({
            bannerUrl: itemParts[0],
            CATID: itemParts[1],
            ListType: itemParts[2],
            MID: itemParts[3],
          });
          isSplit = true;
        } else {
          isSplit = false;
        }
      }
    }

    if (isSplit === true) {
      this.setState({
        dataBanner: structuredArray,
        isSplit: isSplit,
      });
    } else {
      this.setState({
        dataBanner: JSON.parse(dto_StartupPageLoadInfo.AdvertisementUrl),
        isSplit: isSplit,
      });
    }
  }

  render() {
    return (
      <div
        style={{ margin: 10 }}
        className="fadeInUp animated"
        data-wow-duration="300ms"
        data-wow-delay="0ms"
      >
        <Carousel
          dynamicHeight={180}
          showThumbs={false}
          autoPlay={true}
          infiniteLoop={true}
          showArrows={true}
          swipeable={true}
          emulateTouch={false}
        >
          {this.state.dataBanner.map &&
            this.state.dataBanner.map((item) => {
              if (item !== "")
                return (
                  <div
                    key={KEY_GENERATOR()}
                    onClick={async (e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      if (this.state.isSplit === true && item.CATID !== "0") {
                        let rs = await GET_SELECTED_MERCHANT_OR_PRODCUCT();
                        if (rs) {
                          rs.CATID = item.CATID;
                          await set_dto_selected_merchant_or_product(rs);
                        }
                        dto_selected_merchant_or_product.MobileAppUIType = 2;
                        dto_MobileAppCategory.MACID = 1;
                        dto_Merchant.MID = item.MID;
                        dto_selected_merchant_or_product.CATID = item.CATID;
                        dto_MobileAppCategory.ListType = item.ListType;
                        this.props.navigate(
                          PT_PRODUCT_LIST.replace(":navPage", "shome").replace(
                            ":isSec",
                            "false"
                          )
                        );
                      }
                    }}
                  >
                    <img
                      src={this.state.isSplit === true ? item.bannerUrl : item}
                      alt=" "
                      style={{ borderRadius: 5 }}
                    />
                  </div>
                );
            })}
        </Carousel>
      </div>
    );
  }
}
